import UriTemplate from 'uri-templates';
import paypalExpressButton from './paypal_express_button.html';

angular.module('BBPublicBooking').directive('bbPaypalExpressButton', () => {

        return {
            restrict: 'EA',
            replace: true,
            templateUrl: paypalExpressButton.id,
            scope: {
                total: '=',
                bb: '=',
                decideNextPage: '=',
                paypalOptions: '=bbPaypalExpressButton',
                notLoaded: '='
            },
            link(scope) {

                const {total} = scope;
                const {paypalOptions} = scope;
                scope.href = new UriTemplate(total.$link('paypal_express').href).fillFromObject(paypalOptions);

                return scope.showLoader = function () {
                    if (scope.notLoaded) {
                        return scope.notLoaded(scope);
                    }
                };
            }
        };
    }
);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/paypal-buttons/bb_paypal_express_button.directive.js